<table mat-table [dataSource]="dataList" multiTemplateDataRows >
  <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay">
    <th mat-header-cell *matHeaderCellDef> {{column}} </th>
    <td mat-cell *matCellDef="let element"> 
      <div class="flex flex-row justify-start items-center">
        <mat-icon class="text-[#a3aec7]">arrow_right</mat-icon>
        <div class="px-2 font-bold text-lg text-black/70">
          {{element[column]}}
        </div>
      </div>
     
     </td>
  </ng-container>
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
    <td mat-cell *matCellDef="let element" class="w-10">
      <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
        <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
        <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element " [attr.colspan]="columnsToDisplayWithExpand.length">
      <div class="example-element-detail"
           [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
           <div class="w-full border-t-[1px]">
         
            <app-expand-multi-table [data]="element.obj"  (actionReturn)="actionReturnEmit($event)" ></app-expand-multi-table>
           </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand; let i = index"
      class="example-element-row"
      [class.example-expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element">
  </tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="example-detail-row"></tr>
</table>
<div  *ngIf="this.isEmail" class="bg-[#e8e9ec4d] px-2 mb-2 rounded-lg">
  <div *ngFor="let item of this.data.mail | keyvalue">
    <div class="p-2  w-full flex flex-row justify-between border-b-[1px]">
      <div class="flex flex-row justify-start items-center w-full"> 
        <mat-icon class="text-[#233e80]" >mail</mat-icon>
        <div class="px-2"> {{item.value }}</div>
      </div>
      <div>
        <button mat-icon-button  (click)="deleteMail(item)">
          <mat-icon class="text-[#233e80]">delete</mat-icon>
        </button>
      </div>
  
    </div>
  </div>

</div>
<div *ngIf="this.isEmail"  class="w-full flex flex-row justify-end py-4">
  <button class="w-[150px] mx-4"mat-stroked-button color="accent"(click)="edit()">{{utils.traslatei18n('Edit')}}</button>
      <!-- <button class="w-[150px] " mat-stroked-button color="primary" (click)="create()">{{utils.traslatei18n('Create')}}</button> -->
    </div>

